import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AppPageLoader } from "./AppPageLoader";
import { useSession } from "./SessionContext";

export const ProtectedRoute: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, authResolved, bootLoading } = useSession();

  if (!authResolved || bootLoading) {
    return <AppPageLoader text="Подключение..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return <Outlet />;
};
